<app-header-three></app-header-three>

<!-- Home slider start-->
<section class="p-0">
  <app-slider 
    [sliders]="sliders" 
    [textClass]="'text-center'"
    [buttonText]="'view more'"> 
  </app-slider>
</section>
<!-- Home slider End -->

<!-- Product slider start-->
<div class="title1 section-t-space">
  <h4>exclusive</h4>
  <h2 class="title-inner1">services</h2>
</div>
<div class="container">
  <div class="row">
    <div class="col-lg-6 offset-lg-3">
      <div class="product-para">
        <p class="text-center">
          {{textServices}}
        </p>
      </div>
    </div>
  </div>
</div>
<section class="section-b-space p-t-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <owl-carousel-o class="product-m no-arrow" [options]="MeServiceSliderConfig">
          <ng-container *ngFor="let product of meServices | slice:0:16">
              <ng-template carouselSlide>
              <div class="product-box">
                <app-me-service-box 
                  [meService]="product" 
                  [onHowerChangeImage]="false">
                </app-me-service-box>
              </div>
              </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>
<!-- Product slider End -->

    <!-- Parallax banner start-->
    <section class="p-0">
      <div class="full-banner parallax-banner1 parallax text-center p-left"
          [ngStyle]="{'background-image': 'url(assets/images/parallax/Parallax-dsAlpha-3.jpg)'}">
          <div class="container">
            <div class="row">
                <div class="col">
                  <div class="banner-contain">
                      <h2>2023</h2>
                      <h3>Code for the Future, Today</h3>
                      <h4>From Vision to Reality</h4>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </section>
    <!-- Parallax banner End -->

    <!-- Tab product start-->
    <div class="title1 section-t-space">
      <h4>exclusive products</h4>
      <h2 class="title-inner1">why choose us</h2>
    </div>
    <section class="section-b-space p-t-0">
      <div class="container">
          <div class="row">
            <div class="col theme-tab">
           
                    <div class="product-box">
                        <app-why-choose-us-box [whyChooseUs]="whyChooseUs">
                        </app-why-choose-us-box>
                    </div>
            </div>
          </div>
      </div>
    </section>
    <!-- Tab product End -->


<app-footer-one></app-footer-one>